class StatisticsComponent {
    constructor(statisticsComponent) {
        if (!(statisticsComponent instanceof HTMLElement)) {
            throw new TypeError("The element must be an HTML element.");
        }
        
        this.statisticsComponent = statisticsComponent;
        this.backgroundImage = '';
        
    }

    init() {
        this.initSlider();
        //  check if we have a background image to load
        if (this.statisticsComponent.hasAttribute("data-background-image")) {
            this.backgroundImage = this.statisticsComponent.dataset.backgroundImage;
            lazyLoad.initBackgroundLazyLoader(this.statisticsComponent, this.backgroundImage);
        }
    }

    // Initialise the slider used in mobile view
    initSlider() {
        const slider = this.statisticsComponent.querySelector('.statistic-wrapper'); // container with slider
        const controlsContainer = this.statisticsComponent.querySelector('.controls');
        controlsContainer.style.display = 'block';
        // ensure that value within the responsive object below matches the min-width value 
        // of the breakpoint within .statistic-wrapper .statistic-item (ensuring !important is present)
        // of src/scss/components/_statistics.scss
        tns({
            items: 1,
            slideBy: '1',
            container: slider,
            autoplay: false,
            navContainer: true,
            preventScrollOnTouch: 'auto',
            mouseDrag: true,
            nav: false,
            navAsThumbnails: true,
            controlsContainer: controlsContainer,
            rewind: true,
            responsive: {
                768: {
                    items: 4,
                    slideBy: '0',
                },
            },
        });
    }
}

// Check for statistics components when the document has loaded and initialise if we have any 
document.addEventListener("DOMContentLoaded", function () {
    const statisticComponents = document.querySelectorAll('.statistic-component');
    if (statisticComponents) {
        statisticComponents.forEach(function(component) {
            let statsComponent = new StatisticsComponent(component);
            statsComponent.init();
        });
    }
});